import { useState, useCallback } from 'react';
import { Header } from '../components/landing/Header';
import { Hero } from '../components/landing/Hero';
import { About } from '../components/landing/About';
import { Features } from '../components/landing/Features';
import { Packages } from '../components/landing/Packages';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Testimonials } from '../components/landing/Testimonials';
import { FAQ } from '../components/landing/FAQ';
import { Footer } from '../components/landing/Footer';
import { BookingDialog } from '../components/landing/BookingDialog';

export default function LandingPage() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState('couple');

  const handleBookNow = useCallback((packageId) => {
    if (packageId) setSelectedPackage(packageId);
    setBookingOpen(true);
  }, []);

  return (
    <div className="min-h-screen bg-midnight">
      <Header onBookNow={() => handleBookNow()} />
      <Hero onBookNow={() => handleBookNow()} />
      <About />
      <Features />
      <Packages onBookNow={handleBookNow} />
      <HowItWorks />
      <Testimonials />
      <FAQ />
      <Footer onBookNow={() => handleBookNow()} />

      <BookingDialog
        open={bookingOpen}
        onOpenChange={setBookingOpen}
        selectedPackage={selectedPackage}
      />
    </div>
  );
}
